export default "__VITE_ASSET__CAn7sRud__"